@if(searching) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Buscando'"></app-loader>
  </div>
}

<div class="w-full md:space-y-5 mt-5 px-10 overflow-visible">
  <h1 class="text-start text-md text-mustard-700 dark:text-mustard-400 font-bold">Búsqueda</h1>
  <div class="w-full block md:flex justify-between overflow-visible items-end gap-4">
    <div class="w-full md:w-1/2">
      <app-datepicker (updateDates)="setDatesOnFilter($event)"></app-datepicker>
    </div>
    <div class="w-full md:w-auto mt-2 md:mt-0">
      <button pButton label="Buscar" icon="pi pi-search" class="p-button-sm" (click)="obtenerSolicitudes()"></button>
    </div>
  </div>

  @if(!searching) {
    <div class="w-full">
      <div class="relative w-full mx-auto h-full space-y-4 md:space-y-5 mt-5">
        <div class="w-full block md:flex justify-between items-center">
          <h1 class="text-start text-md text-mustard-700 dark:text-mustard-400 font-bold">
            {{ detailRequest ? 'Dispositivos solicitados' : 'Solicitudes realizadas' }}
          </h1>
          @if(detailRequest) {
            <button pButton label="Regresar a solicitudes" icon="pi pi-arrow-left" class="p-button-sm p-button-outlined" (click)="detailRequest=false;cardsOnRequest=[]"></button>
          }
        </div>
        @if(!detailRequest) {
          <div class="mt-5">
            <app-custom-table [elements]="uniqueRequest" [headers]="headersSolicitudes"
              [emptyTableMessage]="'No hay solicitudes entre '+ (requestFrom|date:'dd-MM-yyyy') +' - '+ (requestTo|date:'dd-MM-yyyy')"
              [hasFilter]="true" [hasButton]="true" [actions]="tableButtons"></app-custom-table>
          </div>
        } @else {
          <div class="mt-5">
            <app-custom-table [elements]="cardsOnRequest" [headers]="headerCards" [emptyTableMessage]="''"
              [hasFilter]="true" [hasButton]="false"></app-custom-table>
          </div>
        }
      </div>
    </div>
  }
</div>
